<template>
  <div style="padding-bottom: 40px">
    <div class="plan-page">
      <div class="search-filter">
        <el-row>
          <el-col :span="3">
            <span class="title">
              招生计划
            </span>
          </el-col>
          <el-col :span="20">
            <el-select v-model="year" style="width:120px;margin-right: 20px;" size="mini" class="round_select"
              placeholder="请选择" @change="onChangeYear">
              <el-option v-for="item in yearList" :key="item" :label="item" :value="item" />
            </el-select>
            <el-select v-model="batch" style="width:130px" size="mini" class="round_select" placeholder="请选择"
              @change="onChangeBatch">
              <el-option v-for="item in batchList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-col>
        </el-row>
      </div>


      <div class="college-item">
        <span class="title">招生单位</span>
        <span class="school_name" @click="changeCollege('', null)" :class="{ hove: nav == null }">全部</span>
        <span v-for="(item, i) in NavList" :key="i" @click="changeCollege(item, i)">
          <span class="school_name" :class="{ hove: nav == i }" v-if="item.group_id">
            {{ item.group_id }}
          </span>
        </span>
      </div>


      <div class="table">
        <el-table v-if="tableData" v-loading="loading"
          :header-cell-style="{ 'color': 'black', 'letter-spacing': '1px', 'font-size': '18px', 'font-weight': '400' }"
          :cell-style="{ padding: '4px 0', 'color': 'black' }" :data="tableData"
          style="width: 100%;font-size:16px;text-align:center">
          <el-table-column prop="specialty_id" width="708" label="专业名称">
            <template slot-scope="scope">
              <div class="specialty_name">
                <span>{{ scope.row.specialty_id | interpo }} </span>
                <span>{{ scope.row.specialty_name }}</span>
                <span v-if="scope.row.name != name" style="margin-left: 20px; color: #A7A7A7;">({{ scope.row.name
                }})</span>
              </div>
              <div class="remarks">{{ scope.row.remarks }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="grouping_id" align="center" label="专业组" v-if="batch < 4 && year > 2024" />
          <el-table-column prop="group_demand" align="center" label="选科要求" v-if="year > 2024" width="100" />
          <el-table-column prop="school_id" align="center" label="院校代码" width="100" />
          <el-table-column prop="plan_num" align="center" label="专业计划" width="100" />
          <el-table-column prop="tuition" align="center" label="收费标准" width="100">
            <template slot-scope="scope">
              {{ scope.row.tuition | tuitionFilter }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="批次" v-if="batch == 4">
            <template slot-scope="scope">
              {{ scope.row.pici }}{{ scope.row.pici.fenlei }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="page-pagination">
        <div class="pagination">
          <el-pagination :hide-on-single-page="true" :page-size="page.pageSize" :current-page="page.pageNum"
            :pager-count="11" :total="page.total" class="page-box" layout="prev, pager, next" prev-text='上一页'
            next-text='下一页' @current-change="pageChange" />
        </div>
      </div>
      <div style="font-size:12px;margin:20px 0;color: gray;">备注：以上招生计划仅供参考，最终填报志愿请以河南省教育考试院公布代码和数据为准</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ['school_id'],
  name: "GetPlant",
  computed: { ...mapState(["userInfo"]) },
  data() {
    return {
      name: this.$route.query.name,
      tableData: [],
      batch: null,
      loading: false,
      batchList: [],
      batchData: null,
      year: "2026", // 年份
      yearList: [
        "2026",
        "2025",
        "2024",
        "2023",
        "2022",
      ],
      NavList: null,
      nav: null,
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      grouping_id: null
    };
  },
  filters: {
    tuitionFilter(e) {
      if (e > 0) {
        return e + '元/年'
      } else {
        return '学费暂无'
      }
    }
  },
  mounted() {
    this.getNav()
    // 获取批次/科类列表
    // this.getPlan();
  },
  methods: {
    getNav() {
      if (!this.$route.query.cid) {
        return;
      }
      // 新高考
      this.$fecth
        .get("college_plan/get_group", {
          params: {
            is_wenli: this.userInfo.is_wenli,
            c_id: this.$route.query.cid,
            year: this.year
          },
        })
        .then((res) => {
          if (res) {
            this.batchData = res
            this.batch = res[0].new_batch
            this.NavList = res[0].child
            this.batchList = []
            if (this.year > 2024) {
              res.forEach(element => {
                switch (element.new_batch) {
                  case 1:
                    this.batchList.push({ id: 1, name: "本科批次" })
                    break;
                  case 2:
                    this.batchList.push({ id: 2, name: "专科批次" })
                    break;
                  case 4:
                    this.batchList.push({ id: 4, name: "其他批次" })
                    break;
                }
              });
            } else {
              res.forEach(element => {
                switch (element.new_batch) {
                  case 1:
                    this.batchList.push({ id: 1, name: "本科一批" })
                    break;
                  case 2:
                    this.batchList.push({ id: 2, name: "本科二批" })
                    break;
                  case 3:
                    this.batchList.push({ id: 3, name: "高职高专" })
                    break;
                  case 4:
                    this.batchList.push({ id: 4, name: "其他批次" })
                    break;
                }
              });
            }
            this.getPlan()
          }
        });
    },
    getPlan() {
      this.loading = true
      let data = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        school_id: this.school_id,
        c_id: this.$route.query.cid,
        grouping_id: this.group_id,
        year: this.year,
        new_batch: this.batch,
        is_wenli: this.userInfo.is_wenli
      }
      if (this.year > 2024) {
        this.$fecth
          .get("college_plan/get_college_plan", {
            params: data,
          })
          .then((res) => {
            this.loading = false
            this.tableData = res.lists;
            this.page.total = res.count;
          });
      } else {
        this.$fecth
          .get("college_plan/get_college_plan_old", {
            params: data,
          })
          .then((res) => {
            this.loading = false
            this.tableData = res.lists;
            this.page.total = res.count;
          });
      }


    },
    //招生单位选择
    changeCollege(item, i) {
      this.page.pageNum = 1
      if (item) {
        this.nav = i
        this.group_id = item.group_id
      } else {
        this.nav = null
        this.group_id = null
      }
      this.getPlan()
    },
    onChangeYear() {
      this.nav = null
      this.group_id = null
      this.page.pageNum = 1
      this.getNav()
    },
    onChangeBatch(e) {
      this.nav = null
      this.group_id = null
      this.page.pageNum = 1
      this.batchData.forEach((item) => {
        console.log(item.new_batch)
        if (item.new_batch == e) {
          this.NavList = item.child
        }
      })

      this.getPlan()
    },
    pageChange(page) {
      this.page.pageNum = page
      this.getPlan()
    },
  },

};
</script>

<style lang="less">
.plan-page {
  .search-filter {
    .el-input--mini .el-input__inner {
      background: #F8F8F8;
      border: 0;
      font-size: 16px;
      color: black;
    }

    .el-select .el-input .el-select__caret {
      color: black;
    }
  }
}
</style>

<style lang="less" scoped>
.plan-page {
  width: 1200px;
  margin: auto;
  background-color: #ffffff;
  border-radius: 8px;
  padding-top: 38px;

  .title {
    margin-top: 30px;
    font-size: 22px;
    color: #4591F6;
  }

  .college-item {
    margin-top: 40px;
    margin-bottom: 10px;


    .title {
      font-size: 18px;
      font-weight: normal;
      line-height: 18px;
      color: black;
      margin-right: 30px;

    }

    .school_name {
      color: #A7A7A7;
      border: 1px solid #A7A7A7;
      margin-right: 20px;
      font-size: 18px;
      padding: 2px 5px;
      margin-bottom: 10px;
      border-radius: 5px;
      display: inline-block;
    }

    .hove {
      color: #4591F6;
      border: 1px solid #EFF5FF;
      background: #EFF5FF;
    }
  }

  .table {
    margin: 15px 0 0;

    .specialty_name {
      font-size: 18px;
      color: #000000;
      margin-bottom: 12px;
      margin-top: 24px;
    }

    .remarks {
      font-size: 16px;
      color: #000000;
      margin-bottom: 18px;
    }
  }
}

.page-pagination {
  width: 100%;

  .pagination {
    padding: 40px 0;

    .page-box {
      text-align: center;

      .el-pager li.active {
        background: red;
      }
    }
  }
}
</style>
